<template>
  <div class="device-bg-main">
    <div class="bg-section">
      <v-col
        lg="5"
        md="10"
      >
        <div class="pl-10 pt-10 pb-10 pr-10">
          <div class="header-section">
            <div>
              <h1 class="header-style">
                {{ deviceData.name }}
              </h1>
              <br>
              <p class="subheader-style">
                Search you name for further process
              </p>
            </div>
            <div>
              <img
                width="150px"
                src="../../../../assets/img/swift-checkin-ezybuild-logo.png"
                alt=""
              >
            </div>
          </div>
          <br>
          <v-text-field
            v-model="searchQuery"
            placeholder="Search..."
            outlined
            hide-details
            append-icon="mdi-magnify"
            color="#37474F"
            light
            class="search-bar"
            dense
            flat
            solo
            @keydown.enter="searchHandler"
          />
          <br>
          <div
            v-if="isUsersList"
            class="listing-users"
          >
            <div
              v-for="item in workersList"
              :key="item.id"
              class="lists"
              @click="nextPage(item.phone_number, item.id)"
            >
              <v-row class="listing-section">
                <v-col cols="11">
                  <div class="profile-style">
                    <v-avatar :color="getRandomColor()">
                      <span class="text-h5 short-letter-style">{{ item | filterProfile }}</span>
                    </v-avatar>
                    <span>{{ item.first_name }} {{ item.last_name }}</span>
                  </div>
                </v-col>
                <v-col cols="1">
                  <v-icon color="#37474f">
                    mdi-chevron-right
                  </v-icon>
                </v-col>
              </v-row>
            </div>
            <div class="text-center">
              <v-progress-circular
                v-if="lazyLoader"
                size="25"
                :width="1"
                color="white"
                indeterminate
              />
            </div>
          </div>
          <div
            ref="observer"
            class="observer"
          />
        </div>
      </v-col>
    </div>
    <centre-spinner :loading="loading" />
  </div>
</template>

<script>
import spinner from '../../../components/SpinnerCentre.vue';
export default {
  name: 'HomePage',
  components: {
    'centre-spinner': spinner,
  },
  filters: {
    filterProfile (data) {
      const firstName = data.first_name[0];
      const lastName = data.last_name[0];
      return firstName + lastName;
    },
  },
  data () {
    return {
      searchQuery: null,
      loading: false,
      colors: ['#686EE2', '#5C3E84', '#F35C6E', '#FFA87B'],
      observer: null,
      lazyLoader: false,
      page: 0,
      isUsersList: false,
      lastSearchQuery: null,
    };
  },
  computed: {
    workersList () {
      return this.$store.getters['devices/getWorkerLists'];
    },
    deviceData () {
      return this.$store.getters.getDeviceData;
    },
    getCheckInType () {
      return this.$store.getters['devices/getCheckInType'];
    },
    latestWorkerCallLength () {
      return this.$store.getters['devices/getLatestWorkerCallLength'];
    },
  },
   async mounted () {
    this.loading = true;
    await this.$store.dispatch('devices/clearWorkerLists');
    await this.clearWorkerToken();
    await this.initialWorkersList();
    await this.isNoCheckIntype() && await this.loadMore();

    this.loading = false;
  },
  methods: {
    async clearWorkerToken () {
      this.loading = true;
      await this.$store.dispatch('clearWorkerTokenAndAssignKioskToken');
      this.loading = true;
    },
    getRandomColor () {
      const randomIndex = Math.floor(Math.random() * this.colors.length);
      return this.colors[randomIndex];
    },
    isNoCheckIntype () {
      if (this.getCheckInType === null) {
        this.$router.push({ name: 'DeviceCheckInCheckOut' });
      }
    },
    async searchHandler () {
      if (this.searchQuery !== this.lastSearchQuery) {
        this.lastSearchQuery = this.searchQuery;
      await this.$store.dispatch('devices/clearWorkerLists').then(() => {
        this.page = 0;
        this.initialWorkersList();
      });
    }
    },
    async getWorkersList () {
      this.lazyLoader = true;
      await this.$store.dispatch('devices/fetchWorkersList', {
        orgId: this.deviceData.organization_id.external_id,
        params: {
          params: {
          startPage: this.page,
          limit: 10,
          name: this.searchQuery === '' ? null : this.searchQuery,
          },
        },
      }).then((response) => {
        this.lazyLoader = false;
      }).catch(() => {
        this.lazyLoader = false;
      });
    },
    async initialWorkersList () {
      this.loading = true;
      await this.$store.dispatch('devices/fetchWorkersList', {
        orgId: this.deviceData.organization_id.external_id,
        params: {
          params: {
          startPage: this.page,
          limit: 10,
          name: this.searchQuery === '' ? null : this.searchQuery,
          },
        },
      }).then((response) => {
        this.isUsersList = true;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
    async loadMore () {
      await this.initObserver();
    },
    initObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      this.observer.observe(this.$refs.observer);
    },
    handleIntersect (entries) {
      if (entries[0].isIntersecting) {
        if (this.latestWorkerCallLength.length !== 0) {
          this.page = this.page + 10;
          this.getWorkersList();
      }
      }
    },
    nextPage (phoneNumber, appUserId) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ name: 'DeviceUserLogin', params: { phone_number: phoneNumber, app_user_id: appUserId } });
      }, 1000);
    },
    },
};
</script>

<style scoped>
.header-section{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.listing-users {
  width: 100%;
  border-radius: 40px;
  padding: 10px 10px;
  background: #e7e7e7;
  height: calc(100vh - 15rem);
  overflow-y: auto;
}

.lists {
  width: 100%;
  margin-bottom: 5px;
  padding: 10px 13px;
  border-radius: 100px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.582);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 2px solid rgba(255, 255, 255, 0.445);
}

.lists:hover {
  background: #e7e7e7;
}

.listing-section {
  display: flex;
  align-items: center;
}

.profile-style {
  display: flex;
  gap: 20px;
  align-items: center;
}

.short-letter-style {
  color: white;
}

.search-bar {
  border-radius: 100px;
}
.observer {
  height: 20px;
}
</style>
